import {FETCH_CITIES_REQUEST, FETCH_CITIES_SUCCES, FETCH_CITIES_ERROR} from '../constants/Cities'
import { jsonGet, errorHandler } from '../utils/Request';

const loadCities = () => (dispatch) => {
  const apiUrl = '/cities/list/';
  dispatch({
    type: FETCH_CITIES_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_CITIES_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_CITIES_ERROR
      });
      errorHandler(e);
    });
};

export { loadCities };



// WEBPACK FOOTER //
// ./src/actions/CitiesActions.js